export default __webpack_public_path__ + "static/media/logo.5213f2eb.png";